import { render } from "./Imprimir.vue?vue&type=template&id=734ed284&scoped=true"
import script from "./Imprimir.vue?vue&type=script&lang=js"
export * from "./Imprimir.vue?vue&type=script&lang=js"

import "./Imprimir.vue?vue&type=style&index=0&id=734ed284&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734ed284"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QIcon});
